import type { QuestionnaireItemEnableWhen, QuestionnaireResponseItem } from "fhir/r3"
import { getResponseForLinkId } from "../../fhirUtils/questionnaireUtils"

export function enableWhenConditionsMet(
  conditions: QuestionnaireItemEnableWhen[],
  responses: QuestionnaireResponseItem[],
): boolean {
  const conditionsWithValues = conditions.filter((condition) =>
    Object.keys(condition).some((attribute) => attribute.startsWith("answer")),
  )
  const conditionsWithNoValues = conditions.filter(
    (condition) => !Object.keys(condition).some((attribute) => attribute.startsWith("answer")),
  )

  const hasMatchedValue = conditionsWithValues.some((condition) => {
    const linkedAnswers = getResponseForLinkId(condition.question, responses)?.answer ?? []

    if (condition.answerBoolean != null) {
      return linkedAnswers.some((answer) => answer.valueBoolean === condition.answerBoolean)
    }
    if (condition.answerString != null) {
      return linkedAnswers.some((answer) => answer.valueString === condition.answerString)
    }
    if (condition.answerDate != null) {
      return linkedAnswers.some((answer) => answer.valueDate === condition.answerDate)
    }
    if (condition.answerDateTime != null) {
      return linkedAnswers.some((answer) => answer.valueDateTime === condition.answerDateTime)
    }
    if (condition.answerTime != null) {
      return linkedAnswers.some((answer) => answer.valueTime === condition.answerTime)
    }
    return false
  })

  if (hasMatchedValue) return true

  const onNoValuecondtiions = conditionsWithNoValues.some((condition) => {
    const linkedAnswers = getResponseForLinkId(condition.question, responses)?.answer ?? []
    if (condition.hasAnswer === false) {
      return linkedAnswers.every((answerValue) => {
        return Object.keys(answerValue).length === 0
      })
    }
    if (
      condition.hasAnswer === true &&
      !conditionsWithValues.some((otherConditions) => otherConditions.question === condition.question)
    ) {
      return linkedAnswers.some((answerValue) => {
        return Object.keys(answerValue).length > 0
      })
    }
    return false
  })

  return onNoValuecondtiions
}
